import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ro: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Panou Principal',
        appointments: 'Programări',
        calendar: 'Calendar',
        services: 'Servicii',
        staff: 'Personal',
        resources: 'Resurse',
        customers: 'Clienți',
        settings: 'Setări',
        profile: 'Profil',
        logout: 'Deconectare',
      },
      
      // Common
      common: {
        loading: 'Se încarcă...',
        save: 'Salvează',
        cancel: 'Anulează',
        delete: 'Șterge',
        edit: 'Editează',
        add: 'Adaugă',
        create: 'Creează',
        update: 'Actualizează',
        close: 'Închide',
        yes: 'Da',
        no: 'Nu',
        ok: 'OK',
        search: 'Caută',
        filter: 'Filtrează',
        clear: 'Golește',
        export: 'Exportă',
        import: 'Importă',
        print: 'Printează',
        refresh: 'Reîmprospătează',
        back: 'Înapoi',
        next: 'Următorul',
        previous: 'Precedentul',
        total: 'Total',
        today: 'Azi',
        tomorrow: 'Mâine',
        yesterday: 'Ieri',
        thisWeek: 'Săptămâna aceasta',
        thisMonth: 'Luna aceasta',
        name: 'Nume',
        email: 'Email',
        phone: 'Telefon',
        address: 'Adresă',
        description: 'Descriere',
        notes: 'Notițe',
        status: 'Status',
        date: 'Dată',
        time: 'Oră',
        duration: 'Durată',
        price: 'Preț',
        actions: 'Acțiuni',
      },
      
      // Authentication
      auth: {
        login: 'Autentificare',
        register: 'Înregistrare',
        logout: 'Deconectare',
        email: 'Adresa de email',
        password: 'Parola',
        confirmPassword: 'Confirmă parola',
        forgotPassword: 'Ai uitat parola?',
        resetPassword: 'Resetează parola',
        rememberMe: 'Ține-mă minte',
        loginButton: 'Intră în cont',
        registerButton: 'Creează cont',
        backToLogin: 'Înapoi la autentificare',
        
        // Registration fields
        businessName: 'Numele afacerii',
        subdomain: 'Subdomeniu',
        fullName: 'Numele complet',
        businessType: 'Tipul afacerii',
        phoneNumber: 'Numărul de telefon',
        businessAddress: 'Adresa afacerii',
        
        // Registration steps
        stepBusinessInfo: 'Informații Afacere',
        stepAdminAccount: 'Cont Administrator',
        stepAdditionalDetails: 'Detalii Suplimentare',
        
        // Business types
        salonType: 'Salon de înfrumusețare',
        rentalType: 'Închiriere proprietăți',
        medicalType: 'Cabinet medical',
        notaryType: 'Birou notarial',
        dentalType: 'Cabinet stomatologic',
        legalType: 'Cabinet juridic',
        consultingType: 'Consultanță',
        fitnessType: 'Sală de fitness',
        automotiveType: 'Service auto',
        otherType: 'Altele',
        
        // Messages
        loginSuccess: 'Autentificare reușită!',
        logoutSuccess: 'Deconectare reușită!',
        registerSuccess: 'Contul a fost creat cu succes!',
        invalidCredentials: 'Email sau parolă incorectă',
        accountCreated: 'Contul a fost creat. Vă puteți autentifica acum.',
        
        // Validation
        emailRequired: 'Adresa de email este obligatorie',
        emailInvalid: 'Adresa de email nu este validă',
        passwordRequired: 'Parola este obligatorie',
        passwordTooShort: 'Parola trebuie să aibă cel puțin 8 caractere',
        passwordWeak: 'Parola trebuie să conțină cel puțin o literă mică, o literă mare și o cifră',
        passwordsDontMatch: 'Parolele nu coincid',
        confirmPasswordRequired: 'Confirmarea parolei este obligatorie',
        businessNameRequired: 'Numele afacerii este obligatoriu',
        businessNameTooShort: 'Numele afacerii trebuie să aibă cel puțin 2 caractere',
        businessNameTooLong: 'Numele afacerii nu poate depăși 255 caractere',
        subdomainRequired: 'Subdomeniul este obligatoriu',
        subdomainTooShort: 'Subdomeniul trebuie să aibă cel puțin 3 caractere',
        subdomainTooLong: 'Subdomeniul nu poate depăși 50 caractere',
        subdomainInvalid: 'Subdomeniul poate conține doar litere mici, cifre și liniuțe',
        fullNameRequired: 'Numele complet este obligatoriu',
        fullNameTooShort: 'Numele complet trebuie să aibă cel puțin 2 caractere',
        fullNameTooLong: 'Numele complet nu poate depăși 255 caractere',
        phoneTooLong: 'Numărul de telefon nu poate depăși 50 caractere',
        phoneInvalid: 'Format de telefon invalid',
        addressTooLong: 'Adresa nu poate depăși 500 caractere',
        businessTypeTooLong: 'Tipul de afacere nu poate depăși 100 caractere',
      },
      
      // Dashboard
      dashboard: {
        title: 'Panou Principal',
        welcome: 'Bine ai venit, {{name}}!',
        todayAppointments: 'Programări astăzi',
        weekAppointments: 'Programări săptămâna aceasta',
        totalRevenue: 'Venit total',
        pendingApprovals: 'În așteptarea aprobării',
        upcomingAppointments: 'Programări viitoare',
        recentActivity: 'Activitate recentă',
        quickActions: 'Acțiuni rapide',
        addAppointment: 'Adaugă programare',
        viewCalendar: 'Vezi calendarul',
        manageServices: 'Gestionează serviciile',
        businessSettings: 'Setări afacere',
      },
      
      // Appointments
      appointments: {
        title: 'Programări',
        addAppointment: 'Adaugă programare',
        editAppointment: 'Editează programarea',
        deleteAppointment: 'Șterge programarea',
        appointmentDetails: 'Detalii programare',
        
        // Fields
        client: 'Client',
        clientName: 'Numele clientului',
        clientEmail: 'Email client',
        clientPhone: 'Telefon client',
        service: 'Serviciu',
        staff: 'Personal',
        resource: 'Resursă',
        startTime: 'Ora de început',
        endTime: 'Ora de sfârșit',
        duration: 'Durată',
        price: 'Preț',
        notes: 'Notițe',
        
        // Status
        pending: 'În așteptare',
        confirmed: 'Confirmat',
        cancelled: 'Anulat',
        completed: 'Completat',
        
        // Messages
        appointmentCreated: 'Programarea a fost creată cu succes',
        appointmentUpdated: 'Programarea a fost actualizată cu succes',
        appointmentDeleted: 'Programarea a fost ștearsă cu succes',
        conflictError: 'Există deja o programare în acest interval de timp',
        
        // Actions
        confirm: 'Confirmă',
        cancel: 'Anulează',
        complete: 'Marchează ca finalizat',
        reschedule: 'Reprogramează',
      },
      
      // Calendar
      calendar: {
        title: 'Calendar',
        month: 'Lună',
        week: 'Săptămână',
        day: 'Zi',
        today: 'Astăzi',
        agenda: 'Agendă',
        noEvents: 'Nu există programări în această perioadă',
        
        // Days
        monday: 'Luni',
        tuesday: 'Marți',
        wednesday: 'Miercuri',
        thursday: 'Joi',
        friday: 'Vineri',
        saturday: 'Sâmbătă',
        sunday: 'Duminică',
        
        // Months
        january: 'Ianuarie',
        february: 'Februarie',
        march: 'Martie',
        april: 'Aprilie',
        may: 'Mai',
        june: 'Iunie',
        july: 'Iulie',
        august: 'August',
        september: 'Septembrie',
        october: 'Octombrie',
        november: 'Noiembrie',
        december: 'Decembrie',
      },
      
      // Services
      services: {
        title: 'Servicii',
        addService: 'Adaugă serviciu',
        editService: 'Editează serviciul',
        deleteService: 'Șterge serviciul',
        serviceName: 'Numele serviciului',
        serviceDescription: 'Descrierea serviciului',
        serviceDuration: 'Durata (minute)',
        servicePrice: 'Prețul',
        serviceCategory: 'Categoria',
        active: 'Activ',
        inactive: 'Inactiv',
        
        // Messages
        serviceCreated: 'Serviciul a fost creat cu succes',
        serviceUpdated: 'Serviciul a fost actualizat cu succes',
        serviceDeleted: 'Serviciul a fost șters cu succes',
      },
      
      // Staff
      staff: {
        title: 'Personal',
        addStaff: 'Adaugă membru',
        editStaff: 'Editează membrul',
        deleteStaff: 'Șterge membrul',
        staffName: 'Numele',
        staffEmail: 'Email',
        staffPhone: 'Telefon',
        specialties: 'Specializări',
        workingHours: 'Program de lucru',
        
        // Messages
        staffCreated: 'Membrul a fost adăugat cu succes',
        staffUpdated: 'Membrul a fost actualizat cu succes',
        staffDeleted: 'Membrul a fost șters cu succes',
      },
      
      // Resources
      resources: {
        title: 'Resurse',
        addResource: 'Adaugă resursă',
        editResource: 'Editează resursa',
        deleteResource: 'Șterge resursa',
        resourceName: 'Numele resursei',
        resourceType: 'Tipul resursei',
        resourceDescription: 'Descrierea resursei',
        capacity: 'Capacitatea',
        
        // Types
        room: 'Cameră',
        equipment: 'Echipament',
        vehicle: 'Vehicul',
        other: 'Altele',
        
        // Messages
        resourceCreated: 'Resursa a fost creată cu succes',
        resourceUpdated: 'Resursa a fost actualizată cu succes',
        resourceDeleted: 'Resursa a fost ștearsă cu succes',
      },
      
      // Settings
      settings: {
        title: 'Setări',
        businessInfo: 'Informații afacere',
        workingHours: 'Program de lucru',
        bookingSettings: 'Setări programări',
        notifications: 'Notificări',
        integrations: 'Integrări',
        
        // Business info
        businessName: 'Numele afacerii',
        businessEmail: 'Email afacere',
        businessPhone: 'Telefon afacere',
        businessAddress: 'Adresa afacerii',
        businessType: 'Tipul afacerii',
        
        // Working hours
        enableDay: 'Activează ziua',
        startTime: 'Ora de început',
        endTime: 'Ora de sfârșit',
        
        // Booking settings
        allowOverlap: 'Permite suprapunerea programărilor',
        maxOverlap: 'Numărul maxim de suprapuneri',
        minimumNotice: 'Preaviz minim (minute)',
        maximumAdvance: 'Programare maximă în avans (zile)',
        requireApproval: 'Necesită aprobare',
        autoConfirm: 'Confirmă automat',
        
        // Messages
        settingsUpdated: 'Setările au fost actualizate cu succes',
      },
      
      // Errors
      errors: {
        general: 'A apărut o eroare. Încercați din nou.',
        network: 'Eroare de rețea. Verificați conexiunea la internet.',
        unauthorized: 'Nu aveți permisiunile necesare.',
        notFound: 'Resursa căutată nu a fost găsită.',
        validation: 'Datele introduse nu sunt valide.',
        server: 'Eroare de server. Încercați din nou mai târziu.',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ro',
    fallbackLng: 'ro',
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
